var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('global-layout',[_c('banner'),_c('process'),_c('one-key-access'),_c('multi-scenario-solution')],1)}
var staticRenderFns = []

export { render, staticRenderFns }